import { v4 as uuidv4 } from 'uuid';

import { IColorOption, IMediaLink } from '../types';

import { FONT_PROXIMA_NOVA, FONTS } from './settings';

export const BRANDING_DEFAULT_FONT = FONTS.find((font) => font.id === FONT_PROXIMA_NOVA);

export const DEFAULT_SHOW_LOGO_ON_FOOTER = false;
export const DEFAULT_ENABLE_LOGO_NAVIGATION = false;
export const DEFAULT_IS_NAV_MENU_STICKY = true;
export const DEFAULT_ENABLE_GOOGLE_TRANSLATE = true;

export const WHITE_COLOR = '#FFFFFF';
export const GREY_COLOR = '#CED2D6';
export const BLACK_COLOR = '#131517';
export const PRIMARY_COLOR = '#1F76D8';

export const MEDIALINK = 'mediaLink';
export const FACEBOOK = 'facebook';
/**
 * @deprecated Use `X` instead. Retained for backwards compatibility with
 * persisted media links that were created before Twitter was rebranded to X.
 */
export const TWITTER = 'twitter';
export const TITLE = 'title';
export const LINK = 'link';
export const X = 'x';
export const BRANDING_IDLE_COLORS_BG: IColorOption[] = [
  { colorCode: WHITE_COLOR, selected: false },
  { colorCode: GREY_COLOR, selected: false },
  { colorCode: BLACK_COLOR, selected: false },
  { colorCode: PRIMARY_COLOR, selected: true }
];
export const BRANDING_ACTIVE_COLORS_BG: IColorOption[] = [
  { colorCode: WHITE_COLOR, selected: false },
  { colorCode: GREY_COLOR, selected: false },
  { colorCode: BLACK_COLOR, selected: true },
  { colorCode: PRIMARY_COLOR, selected: false }
];

export const BRANDING_IDLE_COLORS_FONT: IColorOption[] = [
  { colorCode: WHITE_COLOR, selected: true },
  { colorCode: GREY_COLOR, selected: false },
  { colorCode: BLACK_COLOR, selected: false },
  { colorCode: PRIMARY_COLOR, selected: false }
];
export const BRANDING_ACTIVE_COLORS_FONT: IColorOption[] = [
  { colorCode: WHITE_COLOR, selected: true },
  { colorCode: GREY_COLOR, selected: false },
  { colorCode: BLACK_COLOR, selected: false },
  { colorCode: PRIMARY_COLOR, selected: false }
];

export const FOOTER_IDLE_SOCIAL_MEDIA_LINKS: IMediaLink[] = [
  { id: uuidv4(), link: '', type: MEDIALINK, title: '' },
  { id: uuidv4(), link: '', type: FACEBOOK, title: '' },
  { id: uuidv4(), link: '', type: X, title: '' }
];
/**
 * Online Publications - Table of Contents
 */
export enum PublicationTocHeaderHeightOptions {
  Height_450px = '450px',
  Height_600px = '600px',
  Height_720px = '720px',
  Height_900px = '900px'
}

export enum PublicationTocColumnLayoutOptions {
  NumColumns_1 = 1,
  NumColumns_2 = 2,
  NumColumns_3 = 3
}

export const DEFAULT_PUBLICATION_TOC_PAGE_TITLE = 'Table of Contents';
export const DEFAULT_PUBLICATION_TOC_MENU_TITLE = 'Index';
export const DEFAULT_PUBLICATION_TOC_HEIGHT_OPTION = PublicationTocHeaderHeightOptions.Height_600px;
export const DEFAULT_PUBLICATION_TOC_LAYOUT_OPTION = PublicationTocColumnLayoutOptions.NumColumns_1;

export const NAV_MENU_HEIGHT = 82;
export const TOC_PAGE_ID = 'TOC';
export const TOC_MIN_ROWS_PER_COLUMN = 25;

export const GOOGLE_TRANSLATE_CDN = 'https://translate.google.com/translate_a/element.js?cb=googleTranslateElementInit';

export const COPY_WITH_STATUS = 'COPY_WITH_STATUS';
export const COPY_WITHOUT_STATUS = 'COPY_WITHOUT_STATUS';
export const COPY_PLAN_TO_FOLDER = 'COPY_PLAN_TO_FOLDER';
export const COPY_PLAN_TO_PUBLICATION = 'COPY_PLAN_TO_PUBLICATION';
export const CHUNK_SIZE_TO_COPY = 10;

export const CUSTOM_FORMATTING_IDENTIFIER = '//The options below will update the page styling.';
export const GOOGLE_TRANSLATE_IDENTIFIER = 'google_translate_element';
export const EMBED = 'data-media-type="embed"';
